<script>
export default {
  name: 'FullScreenOverlay',
  template: '#fullscreen-overlay-template'
};
</script>